import { render, staticRenderFns } from "./EditorSimple.vue?vue&type=template&id=0f5d0814&"
import script from "./EditorSimple.vue?vue&type=script&lang=js&"
export * from "./EditorSimple.vue?vue&type=script&lang=js&"
import style0 from "./EditorSimple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports